import * as React from 'react';
import { CircumstancesForm } from '../components/CircumstancesForm';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import { WrappedInput } from 'src/share/components/Input/Input';
import { RegionDropdown } from 'src/packages/country-selector/RegionDropdown';
import CountryDropdown from 'src/packages/country-selector/CountryDropdown';

export const CircumstanceLayout = (props: { that: CircumstancesForm }) => {
    return <AdvancedLayout {...props} />
}
export const AdvancedLayout = ({ that }) => (
    <Row className={"margin-forms"}>
        <Country that={that} />
        <Region that={that} />
        <City form={that.props.form} isEditCase={that.props.isEditCase} />
        <Address form={that.props.form} isEditCase={that.props.isEditCase} />
        <Circumstances form={that.props.form} isEditCase={that.props.isEditCase} />
        <LastSeen form={that.props.form} isEditCase={that.props.isEditCase} />
        <MissingDate form={that.props.form} isEditCase={that.props.isEditCase} />
    </Row>
)
const Country = ({ that }) => (
    <Col md={12}>
        <FormGroup>
            {that.props.isEditCase && <Label className="input-margin-top input-label">Country</Label>}
            <CountryDropdown defaultOptionLabel={"Missing Country"} id="country" {...that.regionHandler('country')} />
        </FormGroup>
    </Col>
)
const Region = ({ that }) => (
    <Col md={12}>
        <FormGroup>
            {that.props.isEditCase && <Label className="input-margin-top input-label">Province or State</Label>}
            <RegionDropdown defaultOptionLabel={"Missing Province (non-US) or State(US)"} blankOptionLabel={"Missing Province (non-US) or State(US)"} id="region" country={that.props.caseInfo.country} {...that.regionHandler('state')} />
        </FormGroup>
    </Col>
)
const City = ({ form, isEditCase }) => <WrappedInput md={12} type="text" placeholder="Missing City"  {...form('city', false)} labeltext={isEditCase ? 'City' : ''} />
const Address = ({ form, isEditCase }) => <WrappedInput id="address" md={12} type="text"  {...form('address', false)} placeholder="Address" labeltext={isEditCase ? 'Address' : ''} />
const Circumstances = ({ form, isEditCase }) => (
    <WrappedInput id="missing" md={12} type="textarea" style={{ height: 100 }}  {...form('circumstances', false)} placeholder="Missing Circumstances" labeltext={isEditCase ? 'Missing Circumstances' : ''} />
)
const MissingDate = ({ form, isEditCase }) => (
    <WrappedInput md={12} type="date" placeholder="Missing Date"  {...form('missingDate', true)} labeltext={isEditCase ? 'Missing Date' : ''} />
)
const LastSeen = ({ form, isEditCase }) => <WrappedInput md={12} type="text" placeholder="Last seen" {...form('lastSeen', false)} labeltext={isEditCase ? 'Last Seen' : ''} />